import CountrySelectViewModel from "../../../../countrySelectViewModel";
import TransferRefundForRefundOfRefundsDetailViewModel from "../transferRefundForRefundOfRefundsDetailViewModel";
import { Router } from "@frui.ts/screens";
import type { interfaces } from "inversify";
import type { IPagingFilter } from "@frui.ts/data";
import type TransferType from "entities/transferType";
import AlertsViewModel from "viewModels/alertsViewModel";
import EnumService from "services/enumService";
import LocalizationService from "services/localizationService";
import AppRouter from "services/router";
import RefundForRefundOfRefundsRepository from "repositories/refundForRefundOfRefundsRepository";
import OptionsService from "services/optionsService";
import SecurityService from "services/securityService";
import EventBus from "services/eventBus";
import RefundsApprovalService from "services/refundsApprovalService";
import PriceListService from "services/priceListService";

@Router.registerRoute({ name: Router.Self, route: ":refundId" })
export default class SEPARefundForRefundOfRefundsDetailViewModel extends TransferRefundForRefundOfRefundsDetailViewModel {
  static Factory({ container }: interfaces.Context) {
    return (refundId: string, pagingFilter: IPagingFilter, refundType: TransferType) =>
      new SEPARefundForRefundOfRefundsDetailViewModel(
        refundId,
        pagingFilter,
        refundType,
        container.get(LocalizationService),
        container.get(AppRouter),
        container.get(RefundsApprovalService),
        container.get(RefundForRefundOfRefundsRepository),
        container.get(OptionsService),
        container.get(SecurityService),
        container.get(EventBus),
        container.get(CountrySelectViewModel.Factory),
        container.get(PriceListService),
        container.get(EnumService),
        container.get(AlertsViewModel)
      );
  }
}
